import {
  CHEMICAL_FIELDS,
  CHEMICAL_UNIT_DROPDOWN_OPTIONS,
} from "../chemicalLibrary.constants";

const LABEL = "label";
const VALUE = "value";
const INPUT_TYPE = "inputType";
const TYPE = "type";
const DISABLED = "disabled";

export const ADD_CHEMICAL_CATEGORY_OPTIONS = [
  { value: "acid", label: "acid" },
  { value: "alkali", label: "alkali" },
  { value: "additive", label: "additive" },
];

export const CATEGORY_FILTER_MAP = {
  acid: "acid",
  alkali: "alkali",
  additive: "cip_additive",
};

export const REQUIRED_ADD_CHEMICAL_FIELDS = [
  CHEMICAL_FIELDS.category,
  CHEMICAL_FIELDS.chemical,
  CHEMICAL_FIELDS.symbol,
  CHEMICAL_FIELDS.bulkConcentration,
  CHEMICAL_FIELDS.bulkDensity,
  CHEMICAL_FIELDS.price,
  CHEMICAL_FIELDS.unit,
];

export const SELECTED_CHEMICAL_FIELD_CONFIG = {
  [CHEMICAL_FIELDS.symbol]: {
    sourceKey: "symbol",
    fallback: "",
    disabled: true,
  },
  [CHEMICAL_FIELDS.bulkDensity]: {
    sourceKey: "bulk_density",
    fallback: "0.00",
    disabled: true,
  },
  [CHEMICAL_FIELDS.price]: {
    sourceKey: "price",
    fallback: "",
    disabledWhenNoSelection: true,
  },
  [CHEMICAL_FIELDS.unit]: {
    sourceKey: "unit",
    fallback: "",
    disabledWhenNoSelection: true,
  },
};

export const ADD_EDIT_FORM_CONTROLS = (t, isAddMode = false) => ({
  [CHEMICAL_FIELDS.category]: {
    id: CHEMICAL_FIELDS.category,
    [TYPE]: isAddMode ? "dropdown" : "input",
    [LABEL]: t("chemicalLibrary.category"),
    required: true,
    [VALUE]: "",
    [DISABLED]: false,
    placeholder: t("chemicalLibrary.selectCategory"),
    options: isAddMode ? ADD_CHEMICAL_CATEGORY_OPTIONS : [],
    labelKey: isAddMode ? "value" : "id",
  },
  [CHEMICAL_FIELDS.chemical]: {
    id: CHEMICAL_FIELDS.chemical,
    [LABEL]: t("chemicalLibrary.chemical"),
    required: true,
    [INPUT_TYPE]: "text",
    [TYPE]: isAddMode ? "dropdown" : "input",
    [VALUE]: "",
    [DISABLED]: true,
    placeholder: t("chemicalLibrary.selectChemical"),
    options: [],
    labelKey: "value",
  },
  [CHEMICAL_FIELDS.symbol]: {
    id: CHEMICAL_FIELDS.symbol,
    [LABEL]: t("chemicalLibrary.symbol"),
    [INPUT_TYPE]: "text",
    [TYPE]: "input",
    [VALUE]: "",
    [DISABLED]: true,
  },
  [CHEMICAL_FIELDS.bulkConcentration]: {
    id: CHEMICAL_FIELDS.bulkConcentration,
    [TYPE]: "input",
    [INPUT_TYPE]: "number",
    [LABEL]: t("chemicalLibrary.bulkConcentration"),
    unit: "%",
    [VALUE]: "0",
    [DISABLED]: true,
    roundOff: 2,
    maxDecimals: 2,
    ...(isAddMode ? { range: { min: 0, max: 100 } } : {}),
  },
  [CHEMICAL_FIELDS.bulkDensity]: {
    id: CHEMICAL_FIELDS.bulkDensity,
    [LABEL]: t("chemicalLibrary.bulkDensity"),
    [TYPE]: "input",
    [INPUT_TYPE]: "number",
    unit: "g/cm³",
    [VALUE]: 0.0,
    [DISABLED]: true,
    roundOff: 2,
  },
  [CHEMICAL_FIELDS.price]: {
    id: CHEMICAL_FIELDS.price,
    [LABEL]: t("chemicalLibrary.bulkPrice"),
    [TYPE]: "input",
    [INPUT_TYPE]: "number",
    unit: "$",
    [VALUE]: "0",
    [DISABLED]: true,
    roundOff: 3,
  },
  [CHEMICAL_FIELDS.unit]: {
    id: CHEMICAL_FIELDS.unit,
    [LABEL]: t("chemicalLibrary.type"),
    required: true,
    [TYPE]: "dropdown",
    [VALUE]: "",
    [DISABLED]: true,
    placeholder: t("chemicalLibrary.selectType"),
    options: CHEMICAL_UNIT_DROPDOWN_OPTIONS,
    labelKey: LABEL,
  },
  [CHEMICAL_FIELDS.displayName]: {
    id: CHEMICAL_FIELDS.displayName,
    [LABEL]: t("chemicalLibrary.displayLabel"),
    [INPUT_TYPE]: "text",
    [TYPE]: "input",
    [VALUE]: "",
    [DISABLED]: true,
  },
});
